module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.local) ? _c('link', {
    attrs: {
      "rel": "stylesheet",
      "type": "text/css",
      "href": "node_modules/bootstrap/dist/css/bootstrap.css"
    }
  }) : _c('link', {
    attrs: {
      "href": "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css",
      "rel": "stylesheet",
      "integrity": "sha256-7s5uDGW3AHqw6xtJmNNtr+OBRJUlgkNJEo78P4b0yRw= sha512-nNo+yCHEyn0smMxSswnf/OnX6/KwJuZTlNZBjauKhTK0c+zT+q5JOCx0UFhXQ6rJR9jg6Es8gPuD2uZcYDLqSw==",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container bs-docs-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('getting-started'), _vm._v(" "), _c('accordion-docs'), _vm._v(" "), _c('affix-docs'), _vm._v(" "), _c('alert-docs'), _vm._v(" "), _c('aside-docs'), _vm._v(" "), _c('button-group-docs'), _vm._v(" "), _c('carousel-docs'), _vm._v(" "), _c('checkbox-docs'), _vm._v(" "), _c('datepicker-docs'), _vm._v(" "), _c('dropdown-docs'), _vm._v(" "), _c('form-validator-docs'), _vm._v(" "), _c('input-docs'), _vm._v(" "), _c('modal-docs'), _vm._v(" "), _c('navbar-docs'), _vm._v(" "), _c('popover-docs'), _vm._v(" "), _c('progressbar-docs'), _vm._v(" "), _c('radio-docs'), _vm._v(" "), _c('select-docs'), _vm._v(" "), _c('spinner-docs'), _vm._v(" "), _c('tabs-docs'), _vm._v(" "), _c('toggle-button-docs'), _vm._v(" "), _c('tooltip-docs'), _vm._v(" "), _c('typeahead-docs')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('affix-sidebar')], 1)])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bs-docs-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("VueStrap")]), _vm._v(" "), _c('p', [_vm._v("Bootstrap components built with "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://vuejs.org/"
    }
  }, [_vm._v("Vue.js")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("No jQuery, bootstrap.js, or any 3rd party plugins required.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-outline-inverse btn-lg",
    attrs: {
      "href": "https://github.com/themcaffee/vue-strap"
    }
  }, [_vm._v("Code on GitHub")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "bs-docs-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("Designed and built by "), _c('a', {
    attrs: {
      "href": "https://github.com/yuche/"
    }
  }, [_vm._v("yuche")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Vue 2 version built by "), _c('a', {
    attrs: {
      "href": "https://github.com/wffranco/"
    }
  }, [_vm._v("wffranco")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Expanded on by "), _vm._v("=\"https://github.com/themcaffee/\">themcaffee"), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("\n        Using "), _c('a', {
    attrs: {
      "href": "http://twitter.github.com/bootstrap",
      "target": "_blank"
    }
  }, [_vm._v("Twitter Bootstrap")]), _vm._v("\n        and the "), _c('a', {
    attrs: {
      "href": "css/docs.css",
      "target": "_blank"
    }
  }, [_vm._v("Bootstrap's docs styles")]), _vm._v(" designed and built by "), _c('a', {
    attrs: {
      "href": "http://twitter.com/mdo",
      "target": "_blank"
    }
  }, [_vm._v("@mdo")]), _vm._v("\n        and "), _c('a', {
    attrs: {
      "href": "http://twitter.com/fat",
      "target": "_blank"
    }
  }, [_vm._v("@fat")]), _vm._v(".\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Code licensed under "), _c('a', {
    attrs: {
      "href": "//github.com/mgcrea/angular-strap/blob/master/LICENSE.md",
      "target": "_blank"
    }
  }, [_vm._v("The MIT License")]), _vm._v(",\n        documentation under "), _c('a', {
    attrs: {
      "href": "http://creativecommons.org/licenses/by/3.0/"
    }
  }, [_vm._v("CC BY 3.0")]), _vm._v(".\n      ")])])])
}]}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81651526", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81651526!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/bodyDocs.vue
// module id = 304
// module chunks = 0